module.exports = __webpack_public_path__ + "img/source_book-item5.f294e923.png";